/** 是否有主办方空间入口 */
import ActivitiesEntryBatch, { ActivitiesEntryBatchRes } from '@quickService/ActivitiesEntryBatch';
import useSWR from 'swr';

export const useEntry = () => {
  const { data } = useSWR(
    {
      url: 'ActivitiesEntryBatch',
    },
    () =>
      ActivitiesEntryBatch().then((resp: ActivitiesEntryBatchRes) => ({
        showHost: resp.data.is_host || resp.data.is_host_org_member,
        showLobby: resp.data.is_show_activity_plaza,
      })),
    { revalidateOnFocus: false },
  );
  return data;
};
